// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Folder_accordion__2vWuP","accordionDeactivate":"Folder_accordionDeactivate__347Kx","itemFilter":"Folder_itemFilter__3LbeL","itemCourse":"Folder_itemCourse__3re_W"};